<template>
  <v-layout row style="margin-right: 1px;">
    <v-flex xs11 sm12 offset-sm0 pt-3 pl-4 pr-4>
      <v-card flat style="overflow: visible; height: 320px;">
        <v-subheader style="padding-left: 25px; height: 30px; color: #2f0e4a;   background-color: #dbdbb6;">
          <div  style="width: 20%; overflow: hidden; white-space: nowrap;"> Application number </div>
          <div  style="width: 20%; overflow: hidden; white-space: nowrap;"> Company </div>
          <div  style="width: 15%; overflow: hidden; white-space: nowrap;"> Crop </div>
          <div  style="width: 20%; overflow: hidden; white-space: nowrap;"> Variety </div>
          <div  style="width: 15%; overflow: hidden; white-space: nowrap;"> Country </div>
          <div  style="width: 10%; overflow: hidden; white-space: nowrap;"> Submit-date </div>
        </v-subheader>
        <div>
        <v-list ref='applicationtable' subheader style="background-color: white; padding-bottom: 100px; height: 287px;  overflow-y: scroll; border-bottom: 1px solid #dbdbb6;">
            <v-list-tile
             class="locallist"
              style="border-bottom: 3px solid #dbdbb6;"
              v-for="item in this.applicationlist"
              v-bind:key="item.id"
              @click="getappldetails(item.id, $event)"
              :class="[{active:item.id == selectedid}, {inactive:item.id !== selectedid}]">
              <v-list-tile-action  style="width: 20%;" class="table_item">
                <v-list-tile-title
                  style="padding-left: 5px;"
                  v-html="item.applnumber">
                </v-list-tile-title>
              </v-list-tile-action>
              <v-list-tile-action  style="width: 20%;" class="table_item">
                <v-list-tile-title v-html="item.company"></v-list-tile-title>
              </v-list-tile-action>
              <v-list-tile-action  style="width: 15%;" class="table_item">
                <v-list-tile-title v-html="item.crop"></v-list-tile-title>
              </v-list-tile-action>
              <v-list-tile-action  style="width: 20%;" class="table_item">
                <v-list-tile-title v-html="item.variety"></v-list-tile-title>
              </v-list-tile-action>
              <v-list-tile-action  style="width: 15%;" class="table_item">
                <v-list-tile-title v-html="item.country"></v-list-tile-title>
              </v-list-tile-action>
              <v-list-tile-action  style="width: 10%;" class="table_item">
                <v-list-tile-title v-html="item.submissiondate"></v-list-tile-title>
              </v-list-tile-action>
            </v-list-tile>
        </v-list>
        </div>
      </v-card>
      <hr>
    </v-flex>
  </v-layout>
</template>

<script>

export default {
  watch: {
    applicationlist: function (newVal, oldVal) {
      if (this.applicationactivepage === 'submittedapplications') {
        if (Object.keys(this.$store.getters.getApplicationslistsubmitted).length > 0) {
          let undefinedvalue = false
          if (typeof this.$store.getters.getSelectedapplicationidsubmitted === 'undefined') {
            undefinedvalue = true
          } else {
            if (typeof this.$store.getters.getApplicationslistsubmitted[this.$store.getters.getSelectedapplicationidsubmitted] === 'undefined') {
              undefinedvalue = true
            }
          }
          if (undefinedvalue || (newVal.length !== oldVal.length)) {
            this.$store.commit('setSelectedapplicationidsubmitted', this.$store.getters.getApplicationslistsubmitted[Object.keys(this.$store.getters.getApplicationslistsubmitted)[Object.keys(this.$store.getters.getApplicationslistsubmitted).length - 1]].id)
          }
        } else {
          this.$store.commit('setSelectedapplicationidsubmitted', null)
        }
        // this.$store.commit('setSelectedapplicationid', this.$store.getters.getApplicationslistsubmittedfirstelementid.id)
      }
      if (this.applicationactivepage === 'pendingapplications') {
        if (Object.keys(this.$store.getters.getApplicationslistpending).length > 0) {
          let undefinedvalue = false
          if (typeof this.$store.getters.getSelectedapplicationidpending === 'undefined') {
            undefinedvalue = true
          } else {
            if (typeof this.$store.getters.getApplicationslistpending[this.$store.getters.getSelectedapplicationidpending] === 'undefined') {
              undefinedvalue = true
            }
          }
          if (undefinedvalue || (newVal.length !== oldVal.length)) {
            this.$store.commit('setSelectedapplicationidpending', this.$store.getters.getApplicationslistpending[Object.keys(this.$store.getters.getApplicationslistpending)[Object.keys(this.$store.getters.getApplicationslistpending).length - 1]].id)
          }
        } else {
          this.$store.commit('setSelectedapplicationidpending', null)
        }
      }
      if (this.applicationactivepage === 'approvedapplications') {
        if (Object.keys(this.$store.getters.getApplicationslistapproved).length > 0) {
          let undefinedvalue = false
          if (typeof this.$store.getters.getSelectedapplicationidapproved === 'undefined') {
            undefinedvalue = true
          } else {
            if (typeof this.$store.getters.getApplicationslistapproved[this.$store.getters.getSelectedapplicationidapproved] === 'undefined') {
              undefinedvalue = true
            }
          }
          if (undefinedvalue || (newVal.length !== oldVal.length)) {
            this.$store.commit('setSelectedapplicationidapproved', this.$store.getters.getApplicationslistapproved[Object.keys(this.$store.getters.getApplicationslistapproved)[Object.keys(this.$store.getters.getApplicationslistapproved).length - 1]].id)
          }
        } else {
          this.$store.commit('setSelectedapplicationidapproved', null)
        }
      }
      if (this.applicationactivepage === 'rejectedapplications') {
        if (Object.keys(this.$store.getters.getApplicationslistrejected).length > 0) {
          let undefinedvalue = false
          if (typeof this.$store.getters.getSelectedapplicationidrejected === 'undefined') {
            undefinedvalue = true
          } else {
            if (typeof this.$store.getters.getApplicationslistrejected[this.$store.getters.getSelectedapplicationidrejected] === 'undefined') {
              undefinedvalue = true
            }
          }
          if (undefinedvalue || (newVal.length !== oldVal.length)) {
            this.$store.commit('setSelectedapplicationidrejected', this.$store.getters.getApplicationslistrejected[Object.keys(this.$store.getters.getApplicationslistrejected)[Object.keys(this.$store.getters.getApplicationslistrejected).length - 1]].id)
          }
        } else {
          this.$store.commit('setSelectedapplicationidrejected', null)
        }
      }
      if (this.applicationactivepage === 'verifiedapplications') {
        if (Object.keys(this.$store.getters.getApplicationslistverified).length > 0) {
          let undefinedvalue = false
          if (typeof this.$store.getters.getSelectedapplicationidverified === 'undefined') {
            undefinedvalue = true
          } else {
            if (typeof this.$store.getters.getApplicationslistverified[this.$store.getters.getSelectedapplicationidverified] === 'undefined') {
              undefinedvalue = true
            }
          }
          if (undefinedvalue || (newVal.length !== oldVal.length)) {
            this.$store.commit('setSelectedapplicationidverified', this.$store.getters.getApplicationslistverified[Object.keys(this.$store.getters.getApplicationslistverified)[Object.keys(this.$store.getters.getApplicationslistverified).length - 1]].id)
          }
        } else {
          this.$store.commit('setSelectedapplicationidverified', null)
        }
      }
      if (this.applicationactivepage === 'cancelledapplications') {
        if (Object.keys(this.$store.getters.getApplicationslistcancelled).length > 0) {
          let undefinedvalue = false
          if (typeof this.$store.getters.getSelectedapplicationidcancelled === 'undefined') {
            undefinedvalue = true
          } else {
            if (typeof this.$store.getters.getApplicationslistcancelled[this.$store.getters.getSelectedapplicationidcancelled] === 'undefined') {
              undefinedvalue = true
            }
          }
          if (undefinedvalue || (newVal.length !== oldVal.length)) {
            this.$store.commit('setSelectedapplicationidcancelled', this.$store.getters.getApplicationslistcancelled[Object.keys(this.$store.getters.getApplicationslistcancelled)[Object.keys(this.$store.getters.getApplicationslistcancelled).length - 1]].id)
          }
        } else {
          this.$store.commit('setSelectedapplicationidcancelled', null)
        }
      }
    }
  },
  computed: {
    applicationactivepage () {
      return this.$store.getters.getApplicationactivepage
    },
    applicationlist () {
      console.log('application liust has changed')
      let tempapplicationlist = []
      if (this.applicationactivepage === 'submittedapplications') {
        tempapplicationlist = this.$store.getters.getApplicationslistsubmitted
      }
      if (this.applicationactivepage === 'pendingapplications') {
        tempapplicationlist = this.$store.getters.getApplicationslistpending
      }
      if (this.applicationactivepage === 'verifiedapplications') {
        tempapplicationlist = this.$store.getters.getApplicationslistverified
      }
      if (this.applicationactivepage === 'approvedapplications') {
        tempapplicationlist = this.$store.getters.getApplicationslistapproved
      }
      if (this.applicationactivepage === 'rejectedapplications') {
        tempapplicationlist = this.$store.getters.getApplicationslistrejected
      }
      if (this.applicationactivepage === 'cancelledapplications') {
        tempapplicationlist = this.$store.getters.getApplicationslistcancelled
      }
      // console.log(Object.values(tempapplicationlist))
      return Object.values(tempapplicationlist).slice().reverse()
      // return tempapplicationlist
    },
    selectedid: {
      // getter
      get: function () {
        // console.log(' get the selected application id in applicationlist:' + this.$store.getters.getSelectedapplicationid)
        // return this.$store.getters.getSelectedapplicationid
        if (this.applicationactivepage === 'submittedapplications') {
          return this.$store.getters.getSelectedapplicationidsubmitted
        }
        if (this.applicationactivepage === 'pendingapplications') {
          return this.$store.getters.getSelectedapplicationidpending
        }
        if (this.applicationactivepage === 'verifiedapplications') {
          return this.$store.getters.getSelectedapplicationidverified
        }
        if (this.applicationactivepage === 'approvedapplications') {
          return this.$store.getters.getSelectedapplicationidapproved
        }
        if (this.applicationactivepage === 'rejectedapplications') {
          return this.$store.getters.getSelectedapplicationidrejected
        }
        if (this.applicationactivepage === 'cancelledapplications') {
          return this.$store.getters.getSelectedapplicationidcancelled
        }
      },
      // setter
      set: function (newValue) {
        // console.log('setter computed selectedid change to selected application id')
        if (this.applicationactivepage === 'submittedapplications') {
          this.$store.commit('setSelectedapplicationidsubmitted', newValue)
        }
        if (this.applicationactivepage === 'pendingapplications') {
          this.$store.commit('setSelectedapplicationidpending', newValue)
        }
        if (this.applicationactivepage === 'verifiedapplications') {
          this.$store.commit('setSelectedapplicationidverified', newValue)
        }
        if (this.applicationactivepage === 'approvedapplications') {
          this.$store.commit('setSelectedapplicationidapproved', newValue)
        }
        if (this.applicationactivepage === 'rejectedapplications') {
          this.$store.commit('setSelectedapplicationidrejected', newValue)
        }
        if (this.applicationactivepage === 'cancelledapplications') {
          this.$store.commit('setSelectedapplicationidcancelled', newValue)
        }
        // this.$store.commit('setSelectedapplicationid', newValue)
      }
    }
  },
  data () {
    return {

    }
  },
  methods: {
    getappldetails (itemid) {
      // console.log('changed the selected application id by click event')
      // this.$store.commit('setSelectedapplicationid', itemid)
      if (this.applicationactivepage === 'submittedapplications') {
        this.$store.commit('setSelectedapplicationidsubmitted', itemid)
      }
      if (this.applicationactivepage === 'pendingapplications') {
        this.$store.commit('setSelectedapplicationidpending', itemid)
      }
      if (this.applicationactivepage === 'verifiedapplications') {
        this.$store.commit('setSelectedapplicationidverified', itemid)
      }
      if (this.applicationactivepage === 'approvedapplications') {
        this.$store.commit('setSelectedapplicationidapproved', itemid)
      }
      if (this.applicationactivepage === 'rejectedapplications') {
        this.$store.commit('setSelectedapplicationidrejected', itemid)
      }
      if (this.applicationactivepage === 'cancelledapplications') {
        this.$store.commit('setSelectedapplicationidcancelled', itemid)
      }
    }
  },
  mounted () {

  }
}
</script>
<style scoped>
.active{
  background-color: red;
}
.inactive{
  background-color: #ffffd3;
}
.list__tile__content{
  background-color: #f9fafc;
}
.list__tile__title{
  font-size: 13px;
}
.table_item{
  background-color: #f9fafc;
  color: black;
  width: 150px;
  padding-left: 5px;
  border-left: 3px solid white;
}
.locallist{
  padding-right: 7px !important;
}

</style>



// WEBPACK FOOTER //
// src/components/dashboard/applications/Applicationlist.vue